<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { ensureAiTaskWsConnected } from '@/utils/aiTaskWebSocket'

export default {
  name: 'App',
  created () {
    // 如果本地已存在登录信息（刷新页面或直接打开非登录页）
    // 在应用初始化时尝试建立 / 恢复全局 AI WebSocket 连接
    try {
      const raw = window.localStorage.getItem('planetUserInfo')
      if (raw) {
        ensureAiTaskWsConnected()
      }
    } catch (e) {}
  }
}
</script>

<style lang="scss">
@font-face {
  font-family: 'SourceHanSansCN-Regular';
  src: url('~@/assets/fonts/SourceHanSansCN-Regular.otf') format('opentype');
  font-style: normal;
  font-weight: 400;
  font-display: swap;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body,
#app {
  font-family: 'SourceHanSansCN-Regular', -apple-system, BlinkMacSystemFont,
    'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

button,
input,
textarea,
select {
  font-family: inherit;
}
</style>
